var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal-row',{attrs:{"label":"Tracking Number"}},[_vm._v(" "+_vm._s(_vm.value.ship_tracking)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }